// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main form container */
.form-container {
    max-width: 800px; /* Limit the width of the form */
    margin: 0 auto; /* Center the form horizontally */
    padding: 20px;
    background-color: #f9f9f9; /* Light background color */
    border-radius: 8px; /* Rounded corners */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
  }
  
  /* Form heading */
 .collageheading {
    text-align: center;
    color: #333;
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  /* Label for input fields */
  label {
    display: block;
    font-weight: bold;
    margin-bottom: 8px;
    color: #333;
  }
  
  /* General input field styling */
  input,
  textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    margin-bottom: 16px;
    transition: border-color 0.3s ease;
  }
  
  /* Focused state for input fields */
  input:focus,
  textarea:focus {
    border-color: #4CAF50; /* Green border on focus */
    outline: none;
  }
  
  /* Styling for invalid input fields */
  input.is-invalid,
  textarea.is-invalid {
    border-color: #e74c3c; /* Red border for invalid input */
  }
  
  /* Invalid input message */
  .text-danger {
    color: #e74c3c;
    font-size: 14px;
  }
  
  /* Styling for the submit button */
  .submit-button {
    background-color: #4CAF50; /* Green background */
    color: white;
    padding: 12px 20px;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  /* Hover effect for the submit button */
  .submit-button:hover {
    background-color: #45a049; /* Slightly darker green */
  }
  
  /* Flex layout for email and password fields */
  .form-group {
    margin-bottom: 16px;
  }
  
  .form-container .form-group {
    margin-bottom: 20px;
  }
  
  /* Layout for email and password fields side by side */
  .form-container .form-group.flex {
    display: flex;
    gap: 20px;
  }
  
  /* Each form field (email, password) takes equal width */
  .form-container .form-group.flex .form-group {
    flex: 1 1;
  }
  
  /* Styling for textarea */
  textarea {
    resize: vertical; /* Allow vertical resizing */
    min-height: 100px; /* Minimum height for textarea */
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .form-container {
      padding: 15px;
    }
  
    /* Stack email and password fields vertically on smaller screens */
    .form-container .form-group.flex {
      flex-direction: column;
    }
    
    .form-container .form-group.flex .form-group {
      flex: none;
      width: 100%;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/Collegeform.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,gBAAgB,EAAE,gCAAgC;IAClD,cAAc,EAAE,iCAAiC;IACjD,aAAa;IACb,yBAAyB,EAAE,2BAA2B;IACtD,kBAAkB,EAAE,oBAAoB;IACxC,wCAAwC,EAAE,4BAA4B;EACxE;;EAEA,iBAAiB;CAClB;IACG,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;;EAEA,2BAA2B;EAC3B;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;;EAEA,gCAAgC;EAChC;;IAEE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kCAAkC;EACpC;;EAEA,mCAAmC;EACnC;;IAEE,qBAAqB,EAAE,0BAA0B;IACjD,aAAa;EACf;;EAEA,qCAAqC;EACrC;;IAEE,qBAAqB,EAAE,iCAAiC;EAC1D;;EAEA,0BAA0B;EAC1B;IACE,cAAc;IACd,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,yBAAyB,EAAE,qBAAqB;IAChD,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;EACxC;;EAEA,uCAAuC;EACvC;IACE,yBAAyB,EAAE,0BAA0B;EACvD;;EAEA,8CAA8C;EAC9C;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,sDAAsD;EACtD;IACE,aAAa;IACb,SAAS;EACX;;EAEA,wDAAwD;EACxD;IACE,SAAO;EACT;;EAEA,yBAAyB;EACzB;IACE,gBAAgB,EAAE,4BAA4B;IAC9C,iBAAiB,EAAE,gCAAgC;EACrD;;EAEA,sBAAsB;EACtB;IACE;MACE,aAAa;IACf;;IAEA,kEAAkE;IAClE;MACE,sBAAsB;IACxB;;IAEA;MACE,UAAU;MACV,WAAW;IACb;EACF","sourcesContent":["/* Main form container */\r\n.form-container {\r\n    max-width: 800px; /* Limit the width of the form */\r\n    margin: 0 auto; /* Center the form horizontally */\r\n    padding: 20px;\r\n    background-color: #f9f9f9; /* Light background color */\r\n    border-radius: 8px; /* Rounded corners */\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */\r\n  }\r\n  \r\n  /* Form heading */\r\n .collageheading {\r\n    text-align: center;\r\n    color: #333;\r\n    font-size: 24px;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  /* Label for input fields */\r\n  label {\r\n    display: block;\r\n    font-weight: bold;\r\n    margin-bottom: 8px;\r\n    color: #333;\r\n  }\r\n  \r\n  /* General input field styling */\r\n  input,\r\n  textarea {\r\n    width: 100%;\r\n    padding: 12px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    font-size: 16px;\r\n    margin-bottom: 16px;\r\n    transition: border-color 0.3s ease;\r\n  }\r\n  \r\n  /* Focused state for input fields */\r\n  input:focus,\r\n  textarea:focus {\r\n    border-color: #4CAF50; /* Green border on focus */\r\n    outline: none;\r\n  }\r\n  \r\n  /* Styling for invalid input fields */\r\n  input.is-invalid,\r\n  textarea.is-invalid {\r\n    border-color: #e74c3c; /* Red border for invalid input */\r\n  }\r\n  \r\n  /* Invalid input message */\r\n  .text-danger {\r\n    color: #e74c3c;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  /* Styling for the submit button */\r\n  .submit-button {\r\n    background-color: #4CAF50; /* Green background */\r\n    color: white;\r\n    padding: 12px 20px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  /* Hover effect for the submit button */\r\n  .submit-button:hover {\r\n    background-color: #45a049; /* Slightly darker green */\r\n  }\r\n  \r\n  /* Flex layout for email and password fields */\r\n  .form-group {\r\n    margin-bottom: 16px;\r\n  }\r\n  \r\n  .form-container .form-group {\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  /* Layout for email and password fields side by side */\r\n  .form-container .form-group.flex {\r\n    display: flex;\r\n    gap: 20px;\r\n  }\r\n  \r\n  /* Each form field (email, password) takes equal width */\r\n  .form-container .form-group.flex .form-group {\r\n    flex: 1;\r\n  }\r\n  \r\n  /* Styling for textarea */\r\n  textarea {\r\n    resize: vertical; /* Allow vertical resizing */\r\n    min-height: 100px; /* Minimum height for textarea */\r\n  }\r\n  \r\n  /* Responsive Design */\r\n  @media (max-width: 768px) {\r\n    .form-container {\r\n      padding: 15px;\r\n    }\r\n  \r\n    /* Stack email and password fields vertically on smaller screens */\r\n    .form-container .form-group.flex {\r\n      flex-direction: column;\r\n    }\r\n    \r\n    .form-container .form-group.flex .form-group {\r\n      flex: none;\r\n      width: 100%;\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
